/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentState } from './PaymentState';
import {
    PaymentStateFromJSON,
    PaymentStateFromJSONTyped,
    PaymentStateToJSON,
} from './PaymentState';

/**
 * 
 * @export
 * @interface PaymentPollingDto
 */
export interface PaymentPollingDto {
    /**
     * 
     * @type {PaymentState}
     * @memberof PaymentPollingDto
     */
    paymentState: PaymentState;
    /**
     * 
     * @type {string}
     * @memberof PaymentPollingDto
     */
    paymentReference: string;
}

/**
 * Check if a given object implements the PaymentPollingDto interface.
 */
export function instanceOfPaymentPollingDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "paymentState" in value;
    isInstance = isInstance && "paymentReference" in value;

    return isInstance;
}

export function PaymentPollingDtoFromJSON(json: any): PaymentPollingDto {
    return PaymentPollingDtoFromJSONTyped(json, false);
}

export function PaymentPollingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentPollingDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentState': PaymentStateFromJSON(json['paymentState']),
        'paymentReference': json['paymentReference'],
    };
}

export function PaymentPollingDtoToJSON(value?: PaymentPollingDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentState': PaymentStateToJSON(value.paymentState),
        'paymentReference': value.paymentReference,
    };
}

